import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import type { PriceDeckDetail } from '../types';

interface PriceDeckShowResponse {
  data: PriceDeckDetail;
}

const usePriceDeckDetailAtom = (id: string, asOf?: string | null) =>
  useMemo(() => {
    const param = asOf ? `?as_of=${encodeURIComponent(asOf)}` : '';
    return createResourceAtom<PriceDeckShowResponse>(
      `/price_decks/${id}${param}`
    );
  }, [id, asOf]);

export { usePriceDeckDetailAtom };
export type { PriceDeckShowResponse };
